export function getMaskedCard(value: string | undefined): string {
    if (!value) return '';

    return value.replace(/^(\d{4})(\d{8})(\d{4})/, (match, group1, group2, group3) => {
        // Replace digits in positions 4 to 12 with asterisks
        const maskedMiddle = group2.replace(/\d/g, '*');
        // Return the modified groups
        return group1 + maskedMiddle + group3;
    });
}
